import React from "react";

export const renderDelta = (delta, lowerIsBetter = false, areaType = "Metro") => {
  // General rule: treat 0 values as missing data (0% change is not meaningful)
  if (delta == null || delta === 0) return <span style={{ marginLeft: 6, color: "#666" }}>-</span>;
  const isUp = delta > 0;
  const improved = lowerIsBetter ? !isUp : isUp;
  const arrow = isUp ? "▲" : "▼";
  const color = improved ? "#118a00" : "#c22727";

  // All delta values from Data_UCR are stored in decimal form
  // (e.g., 0.05 = 5%). Convert to percentage for display.
  const percentage = Math.abs(delta * 100);
  
  return (
    <span style={{ color, marginLeft: 6 }}>
      {arrow} {percentage.toFixed(1)}%
    </span>
  );
};

export const formatNumber = (value) => {
  // General rule: treat 0 values as missing data for display purposes
  if (value == null || value === 0) return "-";
  return typeof value === 'number' ? value.toLocaleString() : value;
};

export const formatCurrency = (value) => {
  // General rule: treat 0 values as missing data for display purposes
  if (value == null || value === 0) return "-";
  return typeof value === 'number' ? `$${value.toLocaleString()}` : value;
};

export const formatPercentage = (value) => {
  // General rule: treat 0 values as missing data for display purposes
  if (value == null || value === 0) return "-";
  return typeof value === 'number' ? `${value.toFixed(1)}%` : value;
};

export const getAreaDisplayLabel = (areaType) => {
  return areaType === 'Neighborhood' ? 'Neighbourhood' : (areaType || 'Metro');
};

